<template>
  <div>
    <admin-nav active="formes-juridiques" />
    <b-container fluid>
      <b-row class="mb-1">
        <b-col>
          <h3>Formes juridiques</h3>
          <small class="text-muted">
            Référentiel proposé dans la liste « Forme juridique » à l'étape
            établissement du parcours. Modifications visibles immédiatement.
          </small>
        </b-col>
        <b-col class="text-right">
          <b-button
            variant="primary"
            @click="ouvrirNouvelle"
          >
            <feather-icon icon="PlusIcon" /> Nouvelle forme
          </b-button>
        </b-col>
      </b-row>

      <b-table
        :items="formes"
        :fields="fields"
        striped
        responsive
      >
        <template #cell(actif)="row">
          <b-badge :variant="row.item.actif ? 'success' : 'secondary'">
            {{ row.item.actif ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-50"
            @click="ouvrirEdition(row.item)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            size="sm"
            :variant="row.item.actif ? 'outline-danger' : 'outline-success'"
            @click="toggleActif(row.item)"
          >
            {{ row.item.actif ? 'Désactiver' : 'Activer' }}
          </b-button>
        </template>
      </b-table>

      <!-- Édition / création forme juridique -->
      <b-modal
        v-model="showEdit"
        :title="edit.UI ? 'Modifier la forme juridique' : 'Nouvelle forme juridique'"
        ok-title="Enregistrer"
        cancel-title="Annuler"
        @ok="enregistrer"
      >
        <b-form-group label="Libellé *">
          <b-form-input
            v-model="edit.libelle"
            placeholder="SARL"
          />
        </b-form-group>
        <b-form-group label="Ordre d'affichage">
          <b-form-input
            v-model.number="edit.ordre"
            type="number"
          />
        </b-form-group>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BButton,
  BBadge,
  BModal,
  BFormGroup,
  BFormInput,
  BTable,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AdminNav from './AdminNav.vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
    BBadge,
    BModal,
    BFormGroup,
    BFormInput,
    BTable,
    AdminNav,
  },
  data() {
    return {
      formes: [],
      showEdit: false,
      edit: {},
      fields: [
        {
          key: 'ordre',
          label: '#',
        },
        {
          key: 'libelle',
          label: 'Libellé',
        },
        {
          key: 'actif',
          label: 'Statut',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
    }
  },
  created() {
    this.charger()
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    charger() {
      this.$http.get('/admindom/formes-juridiques', this.authHeaders())
        .then(response => {
          if (response.data.res === 1) this.formes = response.data.formes
          else this.toast('Erreur de chargement', 'danger', 'AlertTriangleIcon')
        })
    },
    ouvrirNouvelle() {
      this.edit = {
        UI: null,
        libelle: '',
        ordre: 100,
      }
      this.showEdit = true
    },
    ouvrirEdition(f) {
      this.edit = { ...f }
      this.showEdit = true
    },
    enregistrer() {
      if (!this.edit.libelle) {
        this.toast('Libellé requis', 'warning', 'AlertTriangleIcon')
        return
      }
      const payload = {
        libelle: this.edit.libelle,
        ordre: this.edit.ordre,
      }
      const req = this.edit.UI
        ? this.$http.patch(`/admindom/formes-juridiques/${this.edit.UI}`, payload, this.authHeaders())
        : this.$http.post('/admindom/formes-juridiques', payload, this.authHeaders())
      req.then(response => {
        if (response.data.res === 1) {
          this.toast('Forme juridique enregistrée', 'success', 'CheckIcon')
          this.charger()
        } else {
          this.toast(response.data.message || 'Erreur', 'danger', 'AlertTriangleIcon')
        }
      })
    },
    toggleActif(f) {
      this.$http.patch(`/admindom/formes-juridiques/${f.UI}`, { actif: !f.actif }, this.authHeaders())
        .then(response => {
          if (response.data.res === 1) {
            this.toast(f.actif ? 'Forme désactivée' : 'Forme activée', 'success', 'CheckIcon')
            this.charger()
          }
        })
    },
    toast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          variant,
          icon,
        },
      })
    },
  },
}
</script>
